export default "__VITE_ASSET__b8a1da07__"